import { CHANNEL_LISTENER_WS } from '../actions';

const INIT_STATE = {
  channelListenerWs: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANNEL_LISTENER_WS:
      return { ...state, channelListenerWs: action.payload };
    default:
      return { ...state };
  }
};
